import(/* webpackMode: "eager" */ "/app/src/app/[lang]/[...not_found]/404.tsx")